import React from "react";

// Circular health score dial (SVG)
export const HealthDial = ({ score = 0, size = 220, label = "Curated Health Score" }) => {
    const stroke = 18;
    const radius = (size - stroke) / 2;
    const circumference = 2 * Math.PI * radius;
    const clamped = Math.max(0, Math.min(100, score));
    const dash = (clamped / 100) * circumference;

    // gradient stops
    const gradientId = "yc-dial-gradient";

    return (
        <div className="relative inline-flex flex-col items-center" data-testid="health-dial">
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                <defs>
                    <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#E3185F" />
                        <stop offset="100%" stopColor="#0038FF" />
                    </linearGradient>
                </defs>
                <circle cx={size / 2} cy={size / 2} r={radius} stroke="#E9EADC" strokeWidth={stroke} fill="white" />
                <circle
                    cx={size / 2} cy={size / 2} r={radius}
                    stroke={`url(#${gradientId})`}
                    strokeWidth={stroke} fill="none"
                    strokeDasharray={`${dash} ${circumference - dash}`}
                    strokeLinecap="round"
                    transform={`rotate(-90 ${size / 2} ${size / 2})`}
                />
                <circle cx={size / 2} cy={size / 2} r={radius} stroke="#16161D" strokeWidth={2} fill="none" />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                <div className="font-heading text-5xl font-black tracking-tighter">{Math.round(clamped)}</div>
                <div className="text-[9px] font-bold uppercase tracking-[0.18em] text-yc-blue text-center leading-tight mt-1.5" style={{ maxWidth: size * 0.55 }}>{label}</div>
            </div>
        </div>
    );
};

export const SubScoreBar = ({ label, value, hint }) => {
    const clamped = Math.max(0, Math.min(100, value));
    return (
        <div className="border-2 border-yc-ink rounded-2xl p-4 bg-white">
            <div className="flex items-baseline justify-between mb-2">
                <span className="font-heading font-bold text-base capitalize">{label.replace("_", " ")}</span>
                <span className="font-heading font-black text-xl">{Math.round(clamped)}</span>
            </div>
            <div className="w-full h-3 bg-yc-cream border-2 border-yc-ink rounded-full overflow-hidden">
                <div className="h-full bg-yc-blue" style={{ width: `${clamped}%` }} />
            </div>
            {hint && <p className="text-xs text-yc-ink/70 mt-2 leading-relaxed">{hint}</p>}
        </div>
    );
};
